import { Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'clu-lockscreen-account-picker-dialog',
    styleUrls: ['clu-lockscreen-account-picker-dialog.component.scss'],
    templateUrl: './clu-lockscreen-account-picker-dialog.component.html',
})
export class CluLockscreenAccountPickerDialog implements OnInit {
    usersAccounts: any[];
    activeUserAccount: any;

    constructor(
        private dialogRef: MatDialogRef<CluLockscreenAccountPickerDialog>,
        @Inject(MAT_DIALOG_DATA) public data: { UsersAccounts: any[], ActiveUserAccount?: any },
    ) {
        this.usersAccounts = data.UsersAccounts;
        this.activeUserAccount = data.ActiveUserAccount;
    }

    ngOnInit() {
    }

    closeDialog(): void {
        this.dialogRef.close();
    }

    doSelectUserAccount(userAccount: any) {
        this.activeUserAccount = userAccount;
    }

    onSubmit() {
        if (!this.activeUserAccount) { return; }

        this.dialogRef.close(this.activeUserAccount);
    }
}